import { HourglassMedium, PauseCircle, CurrencyDollar } from "@phosphor-icons/react";

export const HOLDS = ["Waiting on Customer", "Waiting on Material", "Waiting on Payment"];

const daysSince = (iso) =>
  iso ? Math.max(0, Math.floor((Date.now() - Date.parse(iso)) / 86400000)) : null;

// Amber "Waiting on…" flag shared by projects, quotes and the dashboard feed.
export const HoldBadge = ({ status, since, note, className = "", testId = "hold-badge" }) => {
  if (!status) return null;
  const d = daysSince(since);
  const Icon =
    status === "Waiting on Material"
      ? HourglassMedium
      : status === "Waiting on Payment"
        ? CurrencyDollar
        : PauseCircle;
  return (
    <span
      data-testid={testId}
      title={note || status}
      className={`inline-flex items-center gap-1 rounded-full border border-amber-500/40 bg-amber-500/15 px-2 py-0.5 text-[10px] font-bold uppercase tracking-widest text-amber-300 ${className}`}
    >
      <Icon size={11} weight="fill" />
      {status}
      {d != null && d > 0 && <span className="font-mono-data text-amber-200/70">· {d}d</span>}
    </span>
  );
};

// Compact select + note used on the project header and the quote builder.
export const HoldControl = ({ status, note, onChange, disabled, testId = "hold" }) => (
  <div className="flex flex-wrap items-center gap-2" data-testid={`${testId}-control`}>
    <select
      data-testid={`${testId}-select`}
      value={status || ""}
      disabled={disabled}
      onChange={(e) => onChange({ hold_status: e.target.value, hold_note: e.target.value ? note || "" : "" })}
      className={`h-9 rounded-full border px-3 text-[10px] font-bold uppercase tracking-widest outline-none transition-colors duration-150 disabled:opacity-50 ${
        status
          ? "border-amber-500/40 bg-amber-500/10 text-amber-200"
          : "border-zinc-700 bg-zinc-950 text-zinc-400 hover:border-zinc-500"
      }`}
    >
      <option value="">Not waiting</option>
      {HOLDS.map((h) => (
        <option key={h} value={h}>
          {h}
        </option>
      ))}
    </select>
    {status && (
      <input
        data-testid={`${testId}-note`}
        defaultValue={note || ""}
        key={`${status}-${note || ""}`}
        placeholder="What are we waiting on?"
        disabled={disabled}
        onBlur={(e) => e.target.value !== (note || "") && onChange({ hold_status: status, hold_note: e.target.value })}
        onKeyDown={(e) => e.key === "Enter" && e.currentTarget.blur()}
        className="h-9 w-full min-w-0 rounded-full border border-zinc-700 bg-zinc-950 px-3 text-xs text-zinc-200 outline-none placeholder:text-zinc-600 focus:border-amber-500/50 sm:w-56"
      />
    )}
  </div>
);
